// Not feature-specific: the same three answers apply to anything a person or the system can change.
export enum EChangeSource {
  Admin = 'admin',
  System = 'system',
  Trial = 'trial',
  // Backfilled from a row timestamp: the date is real, the actor was never recorded.
  Unknown = 'unknown',
}

// VARCHAR(255). recordFeatureChanges swallows the insert error, so an over-long note loses the record.
export const NOTE_MAX = 255

// A reset writes a removal row per key; without this they read as values vanishing one by one.
export const resetToPlanNote = (planName?: string) => `Reset to the ${planName || 'customer'} plan`
